import { motion } from "framer-motion";
import { Reveal } from "../../lib/motion";
import { IMAGES, PROTECTIONS } from "../../lib/siteData";

export const Protection = () => {
  return (
    <section
      id="protection"
      data-testid="protection-section"
      className="relative py-28 lg:py-40 bg-[#0F1012] text-[#F9F8F6] overflow-hidden"
    >
      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <Reveal className="lg:col-span-6 order-2">
            <div className="relative overflow-hidden rounded-sm h-[46vh] lg:h-[60vh]">
              <img
                src={IMAGES.identityProtection}
                alt="A luminous human identity remaining intact within a soft protective field of light"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <motion.img
                src={IMAGES.identityProtectionClean}
                alt="A luminous human identity remaining intact within a soft protective field of light"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: false, amount: 0.35 }}
                transition={{ duration: 5, ease: "easeInOut" }}
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-white/10" />
            </div>
          </Reveal>

          <div className="lg:col-span-6 order-1">
            <Reveal>
              <p className="text-[11px] uppercase tracking-[0.4em] text-[#C5B498] mb-6">
                Identity protection
              </p>
              <h2 className="font-serif font-light tracking-tight leading-[1.02] text-[clamp(2rem,4.6vw,3.8rem)] max-w-xl text-balance">
                Protection is part of legacy.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 text-[#9A9C9F] text-base sm:text-lg leading-relaxed max-w-xl">
                The ability to reproduce a person's voice or likeness does not create the
                right to do so.
              </p>
              <p className="mt-4 text-[#9A9C9F] text-base sm:text-lg leading-relaxed max-w-xl">
                EverSoul is designed to record what a person authorizes, what they restrict,
                who may act on their behalf, and whether any interactive representation may
                exist at all.
              </p>
            </Reveal>

            <div className="mt-10 border-t border-[#2A2C31]">
              {PROTECTIONS.map((p, i) => (
                <Reveal key={p} delay={i * 0.05}>
                  <div className="flex items-baseline gap-4 border-b border-[#2A2C31] py-4">
                    <span className="text-[11px] tracking-[0.3em] text-[#C5B498] shrink-0">
                      {`0${i + 1}`}
                    </span>
                    <span className="text-[#e6e2d8] text-[15px] leading-relaxed">{p}</span>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal delay={0.1}>
              <p className="mt-10 font-serif italic text-[#e6e2d8] text-lg sm:text-xl leading-snug max-w-lg">
                A digital legacy should never become something its owner did not choose.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
